import { useState } from "react";
import { api } from "@/lib/api";
import RichTextEditor from "@/pages/admin/RichTextEditor";

export default function JobsManager({ items, reload }) {
  const empty = { title: "", location: "", type: "Tempo pieno", description: "", is_open: true, order: 0 };
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const startEdit = (it) => {
    setEditingId(it.id);
    setForm({ title: it.title, location: it.location || "", type: it.type || "Tempo pieno", description: it.description || "", is_open: it.is_open !== false, order: it.order || 0 });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const reset = () => { setForm(empty); setEditingId(null); };

  const save = async () => {
    if (!form.title.trim()) { alert("Inserisci un titolo."); return; }
    setBusy(true);
    try {
      if (editingId) await api.put(`/jobs/${editingId}`, form);
      else await api.post("/jobs", form);
      reset();
      reload();
    } catch {
      alert("Salvataggio non riuscito.");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questo annuncio?")) return;
    await api.delete(`/jobs/${id}`);
    reload();
  };

  const toggleOpen = async (it) => {
    await api.put(`/jobs/${it.id}`, { ...it, is_open: !it.is_open });
    reload();
  };

  return (
    <div>
      <div className="adm-card">
        <h3>{editingId ? "Modifica annuncio" : "Nuovo annuncio di lavoro"}</h3>
        <div className="adm-field">
          <label>Titolo posizione *</label>
          <input value={form.title} onChange={(e) => set("title", e.target.value)} placeholder="Es. Tecnico Fibra Ottica" data-testid="job-title" />
        </div>
        <div className="adm-grid2">
          <div className="adm-field"><label>Luogo</label><input value={form.location} onChange={(e) => set("location", e.target.value)} placeholder="Es. Somma Vesuviana (NA)" data-testid="job-location" /></div>
          <div className="adm-field"><label>Tipo di contratto</label>
            <select value={form.type} onChange={(e) => set("type", e.target.value)} data-testid="job-type">
              <option>Tempo pieno</option>
              <option>Part-time</option>
              <option>Stage / Tirocinio</option>
              <option>Contratto a progetto</option>
              <option>Apprendistato</option>
            </select>
          </div>
        </div>
        <div className="adm-field">
          <label>Descrizione</label>
          <RichTextEditor key={editingId || "new"} value={form.description} onChange={(v) => set("description", v)} testid="job-description" />
        </div>
        <div className="adm-grid2">
          <div className="adm-field"><label>Ordine</label><input type="number" value={form.order} onChange={(e) => set("order", Number(e.target.value))} /></div>
          <div className="adm-field"><label>Stato</label>
            <select value={form.is_open ? "1" : "0"} onChange={(e) => set("is_open", e.target.value === "1")} data-testid="job-status">
              <option value="1">Aperta (visibile sul sito)</option>
              <option value="0">Chiusa (nascosta)</option>
            </select>
          </div>
        </div>
        <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
          <button className="adm-btn" onClick={save} disabled={busy} data-testid="job-save-btn">
            {editingId ? "Salva modifiche" : "Pubblica annuncio"}
          </button>
          {editingId && <button className="adm-btn ghost" onClick={reset}>Annulla</button>}
        </div>
      </div>

      <div className="adm-card">
        <h3>Annunci ({items.length})</h3>
        {items.length === 0 ? (
          <p className="adm-empty">Nessun annuncio. Crea il primo qui sopra.</p>
        ) : (
          <div data-testid="jobs-admin-list">
            {items.map((it) => (
              <div className="adm-pf-item" key={it.id} style={{ marginBottom: 12 }}>
                <div className="meta">
                  <span className="cat">{it.location || "—"} · {it.type || "—"} · {it.is_open ? "Aperta" : "Chiusa"}</span>
                  <h4>{it.title}</h4>
                  <div className="job-desc-preview" dangerouslySetInnerHTML={{ __html: it.description || "" }} />
                </div>
                <div className="actions">
                  <button className="adm-btn ghost sm" onClick={() => startEdit(it)} data-testid={`job-edit-${it.id}`}>Modifica</button>
                  <button className="adm-btn ghost sm" onClick={() => toggleOpen(it)}>{it.is_open ? "Chiudi" : "Riapri"}</button>
                  <button className="adm-btn danger sm" onClick={() => remove(it.id)} data-testid={`job-delete-${it.id}`}>Elimina</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
